export default __webpack_public_path__ + "static/media/job_interview_.e6d3641a.svg";